<template>
  <div class="home-bg">
    <div class="home-bg-code">
      <div class="home-container">
        <div class="home-title" v-show="isEnterprise">
          <span :style="{ color: '#333333' }">长按识别企业专属 </span>
          <span :style="{ color: '#3A71FFFF' }">二维码 </span>
        </div>
        <div class="home-title2" v-show="isEnterprise">
          <span :style="{ color: '#333333' }">快速加入企业完成注册 </span>
        </div>
        <img v-show="isEnterprise" src="@/assets/images/home_down.png" style="margin:12px auto 0;display: block;">
        <div class="home-bg-shadow" :style="dynamicStyles()">
          <div class="home-bg-line">
            <vueQr :text="imageUrl" :size="getQrSize()" v-if="imageUrl"></vueQr>
          </div>
        </div>
        <van-button round type="info" class="home-bg-share" @click="showCode = true">{{ shareTint() }}</van-button>
      </div>
    </div>

    <!-- <img class="home-bg-bottom"/> -->
    <img src="@/assets/images/home_bottom.png" width="90%" style="margin:5% auto 0;display: block;" />

     <van-overlay :show="showCode" @click="showCode = false">
      <div class="wrapper">
        <img src="@/assets/img/jt.jpg" alt="" width="100%">
      </div>
    </van-overlay>
  </div>
</template>

<script>
import vueQr from "vue-qr"
import wxLogin from '@/utils/wx';
import wxShare from 'weixin-js-sdk'
import request from "@/utils/request";

export default {
  components: {
    vueQr,
  },
  data() {
    return {
      showCode: false,
      userData: "",
      imageUrl: "",
      isEnterprise: false,
    };
  },
  created() {
    // wxLogin.toWXLogin((status, data) => {
    //   if (status == 1) {
    //     this.isEnterprise = !(data.duty == 1 || data.duty == 9)
    //     this.userData = data
    //     console.log('duty====>' + this.userData.duty);

    //     this.getGZHSign()
    //     if (!this.isEnterprise) {
    //       this.getBinQRCode()
    //     } else {
    //       this.imageUrl = process.env.VUE_APP_BASE_API + "/personRegister?invitedid=" + this.userData.firmId + "&isenterprise=" + this.isEnterprise
    //     }
    //   }
    // })
  },
  methods: {
    getQrData() {
      var url = ""
      if (this.isEnterprise) {
        url = process.env.VUE_APP_BASE_API + "/personRegister?invitedid=" + this.userData.firmId + "&isenterprise=" + this.isEnterprise
      } else {
        url = process.env.VUE_APP_BASE_API + "/personRegister?invitedid=" + this.userData.id + "&isenterprise=" + this.isEnterprise
      }
      return url
    },
    dynamicStyles() {
      if (this.isEnterprise) {
        return {
          marginTop: '10px',
        };
      } else {
        return {
          marginTop: '80px',
        };
      }
    },
    getQrSize() {
      return window.innerWidth * 0.50;
    },
    shareTint() {
      if (this.isEnterprise) {
        return "点击右上角分享邀请加入企业";
      } else {
        return "点击右上角分享客户";
      }

    },

    initShare(data) {
      wxLogin.shareData.desc = this.getShareTiTle()
      wxLogin.shareData.link = this.getQrData()

      wxShare.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wxLogin.getAPPID(), // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
      });

      wxShare.ready(function () {
        console.log('==微信分享初始化成功==>');
        // //分享给朋友
        wxShare.updateAppMessageShareData({
          title: wxLogin.shareData.title, // 分享标题
          desc: wxLogin.shareData.desc, // 分享描述
          link: wxLogin.shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: wxLogin.shareData.imgUrl, // 分享图标
          success: function () {
            console.log('share==朋友设置成功==>');
          }
        })
        //分享到朋友圈
        wxShare.updateTimelineShareData({
          title: wxLogin.shareData.desc, // 分享标题
          link: wxLogin.shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: wxLogin.shareData.imgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('share==朋友圈设置成功==>');
          }
        })
      });
      wxShare.error(function (res) {
        console.log('==微信分享初始化失败==>' + res);
      });
      wxShare.checkJsApi({
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          console.log(JSON.parse(res));
        }
      });
    },
    getShareTiTle() {
      return this.userData.name + "邀请你加入" + this.userData.enterpriseName
    },
    getGZHSign() {
      request.get("/Data/WeChat/GetGZHSign", { params: { url: window.location.href.split("#")[0] } }).then((res) => {
        this.initShare(res.data.data)
      }).catch(() => { });
    },
    getBinQRCode() {
      request.get("/Data/ReportTask/CgiBinQRCode", { params: { value: this.userData.id } })
        .then((res) => {
          this.imageUrl = res.data.data.url
        })
        .catch(() => { });
    },
  }
};
</script>

<style lang="less">
.home-bg {
  position: absolute;
  background: url('../../assets/images/home_bg.png') center center no-repeat;
  background-size: 100% 100%;
  /* 覆盖整个元素，保持图像比例 */
  width: 100vw;
  /* 视口宽度 */
  height: 100vh;
  /* 视口高度 */
}

.home-container {
  display: flex;
  flex-direction: column;
}

.home-title {
  flex: 1;
  margin-left: 46px;
  margin-top: 3vw;
}

.home-title2 {
  flex: 1;
  margin-left: 138px;
}

.home-bg-code {
  flex: 1;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 40vw;
  background-color: #fff;
  border-radius: 12px;
  width: 90%;
  height: 110vw;
}

.home-bg-shadow {
  flex: 1;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 10px;
  background-image: url('../../assets/images/home_bro.png');
  background-size: 100% 100%;
}

.home-bg-line {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
  margin-left: 10%;
  margin-right: 10%;
  top: 3vw;
  border-radius: 12px;
  border: 1px solid #3A71FF4D;
  width: 70%;
  height: 55vw;
  padding: 12px;
}

.home-bg-share {
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 12px;
}

.home-bg-bottom {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
  src: url('../../assets/images/home_bottom.png');
  width: 100%;
  height: auto;
}

.home-register {
  width: 100%;
  padding: 20px;
}

.home-register-title {
  width: 100%;
  text-align: center;
  /* 水平居中 */
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  &>img {
    position: absolute;
    top: 0;
  }
}

</style>
